<template>
    <v-app-bar app dense color="secondary" dark>
        <v-app-bar-nav-icon @click.stop="onDrawer"></v-app-bar-nav-icon>
        <v-toolbar-title></v-toolbar-title>
        <v-spacer></v-spacer>
            <div class="text-center" v-if="$root.isTouch == false">
                <span style="font-size: 0.9em;" v-html="nameUser"></span>
            </div>
            <div class="text-center ml-2 mr-2" v-if="isCliente">
                <v-menu top offset-x class="mt-5" max-width="30%" absolute max-height="500">
                    <template v-slot:activator="{ on }">
                        <v-badge 
                            :content="notifications.messages"
                            :value="notifications.messages"
                            :color="notifications.color"
                            overlap                            
                        >
                            <v-icon v-on="on">notifications</v-icon>
                        </v-badge>
                    </template>

                    <v-list dense style="z-index:1000000">
                        <v-list-item dense v-for="(item, index) in _.get(notifications,'data',[])" :key="index" @click="onAcction(item)">
                            <!-- <v-list-item-icon>
                                <v-icon dense v-text="item.icono"></v-icon>
                            </v-list-item-icon> -->
                            <v-list-item-content>
                                <v-list-item-title>{{ item.tituloNotificacion }}</v-list-item-title>
                                <v-list-item-subtitle>{{ item.notificacion }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider></v-divider>
                        <v-btn text block color="primary" @click="open=true">
                            <span>Ver Detalle</span>
                        </v-btn>
                    </v-list>
                </v-menu>
            </div>
            
            <div class="text-center">
                <v-menu top offset-x>
                    <template v-slot:activator="{ on }">
                        <v-btn icon color="white" v-on="on">
                            <v-icon>person</v-icon>
                        </v-btn>
                    </template>

                    <v-list dense>
                        <v-list-item dense v-for="(item, index) in items" :key="index" @click="onAcction(item)">
                            <v-list-item-icon>
                                <v-icon dense v-text="item.icono"></v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </div>

            <div class="text-center">
                <ModalNotificacionComponent :load="open"/>
            </div>
    </v-app-bar>
</template>

<script>
    export default {
        components:{
            ModalNotificacionComponent: () => import('@/components/utilites/ModalNotificacionComponent.vue')
        },
        props: {
            drawer: {
                type: Boolean,
                default: true
            },
            notifications:{
                type:Object,
                default:{}
            }
        },
        data:()=>({
            open:false
        }),
        computed:{
            items(){
                return [
                    { title: 'Información', value: 'I', icono: 'person' },
                    { title: !_.get(this,['$vuetify','theme','dark'],false) ? 'Modo Nocturno' : 'Desactivar Modo Nocturno', value: 'N', icono: 'wb_sunny' },
                    { title: 'Cerrar Sesión', value: 'S', icono:'exit_to_app' },
                ];
            },
            nameUser(){
                return `${_.get(this.$root.obUsuario,'perfil','N/A')}: ${_.get(this.$root.obUsuario,'nombres','N/A')}`
            },
            isCliente(){
                return _.size(_.get(this.$root.obUsuario,'idCliente','')) > 0 ? true : false;
            }
        },
        methods:{
            onAcction(objeto){
                switch (objeto.value) {
                    case 'N':
                        this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
                        break;
                    case 'I':
                        this.$router.push('/informacion/usuario');
                        break;
                    case 'S':
                        localStorage.clear();
                        axios.defaults.headers.common['Authorization'] = null;
                        this.$router.push('/');
                        break;
                }
            },
            onDrawer(){
                this.$root.drawer = !this.$root.drawer;
            },
            close(){
                this.open = false;
            }
        },
        provide(){
            return{
                close:this.close
            }
        }
    }
</script>